// 512 farklı gündelik kelime; Türkçe klavye ve büyük harf gerektirmez.
// Kategoriler yalnızca havuzu düzenler; iki seçim de tüm havuzdan bağımsız yapılır.
const KELIMELER = [
    "elma", "armut", "ayva", "erik", "kiraz", "visne", "muz", "kivi",
    "kavun", "karpuz", "incir", "uzum", "dut", "nar", "limon", "portakal",
    "mandalina", "greyfurt", "kayisi", "seftali", "nektarin", "ananas", "mango", "avokado",
    "hurma", "kestane", "ceviz", "findik", "badem", "fistik", "zeytin", "yabanmersini",
    "domates", "biber", "patates", "patlican", "kabak", "havuc", "turp", "pancar",
    "lahana", "marul", "roka", "tere", "nane", "maydanoz", "dereotu", "feslegen",
    "kekik", "reyhan", "enginar", "kereviz", "bamya", "bezelye", "fasulye", "mercimek",
    "nohut", "pirasa", "ispanak", "brokoli", "karnabahar", "salatalik", "mantar", "semizotu",
    "papatya", "lale", "menekse", "orkide", "zambak", "karanfil", "lavanta", "yasemin",
    "nergis", "nilufer", "manolya", "akasya", "begonya", "petunya", "fulya", "sardunya",
    "cinar", "mese", "cam", "sedir", "ladin", "kavak", "sogut", "ihlamur",
    "defne", "palmiye", "servi", "ardic", "kayin", "bambu", "fidan", "kozalak",
    "deniz", "nehir", "irmak", "dere", "pinar", "gol", "ada", "orman",
    "dag", "tepe", "vadi", "ova", "yayla", "bahce", "yaprak", "cimen",
    "bulut", "yagmur", "damla", "ruzgar", "gunes", "yildiz", "ayisik", "ufuk",
    "serce", "kumru", "turna", "leylek", "kelebek", "yunus", "balina", "ceylan",
    // Uzay
    "merkur", "venus", "dunya", "mars", "jupiter", "saturn", "uranus", "neptun",
    "pluto", "ay", "galaksi", "evren", "meteor", "kuyruklu", "takimyildiz", "roket",
    // Aylar ve mevsimler
    "ocak", "subat", "mart", "nisan", "mayis", "haziran", "temmuz", "agustos",
    "eylul", "ekim", "kasim", "aralik", "ilkbahar", "yaz", "sonbahar", "kis",
    // Renkler
    "mavi", "yesil", "sari", "kirmizi", "mor", "pembe", "turuncu", "beyaz",
    "siyah", "gri", "lacivert", "turkuaz", "bordo", "eflatun", "bej", "kahverengi",
    // Memeliler
    "kedi", "kopek", "tavsan", "sincap", "kirpi", "tilki", "kurt", "aslan",
    "kaplan", "leopar", "zebra", "zurafa", "fil", "panda", "koala", "kanguru",
    // Kuslar
    "kartal", "sahin", "baykus", "papagan", "penguen", "flamingo", "pelikan", "marti",
    "guvercin", "karga", "ibibik", "bildircin", "kanarya", "saka", "tavus", "ordek",
    // Deniz canlilari ve bocekler
    "hamsi", "levrek", "palamut", "sazan", "alabalik", "somon", "ahtapot", "yengec",
    "karides", "midye", "istiridye", "mercan", "ari", "karinca", "ugurbocegi", "atesbocegi",
    // Ev esyalari
    "perde", "yastik", "yorgan", "yatak", "dolap", "masa", "sandalye", "koltuk",
    "hali", "kilim", "lamba", "ayna", "saat", "vazo", "sepet", "sandik",
    // Mutfak
    "tabak", "kase", "bardak", "fincan", "tepsi", "tencere", "tava", "cezve",
    "kasik", "catal", "bicak", "kepce", "suzgec", "rende", "kavanoz", "surahi",
    // Okul
    "kitap", "defter", "kalem", "silgi", "cetvel", "pergel", "makas", "boya",
    "kagit", "dosya", "tahta", "tebesir", "sozluk", "atlas", "harita", "abakus",
    // Muzik
    "keman", "gitar", "piyano", "flut", "davul", "zurna", "saz", "baglama",
    "ud", "ney", "kanun", "klarnet", "trompet", "tulum", "arp", "zil",
    // Ulasim
    "araba", "otobus", "tren", "vagon", "tramvay", "metro", "vapur", "gemi",
    "tekne", "sandal", "ucak", "balon", "bisiklet", "scooter", "traktor", "kamyon",
    // Giyim
    "gomlek", "kazak", "hirka", "mont", "palto", "ceket", "yelek", "etek",
    "elbise", "pantolon", "corap", "sapka", "bere", "atki", "eldiven", "terlik",
    // Yiyecekler
    "ekmek", "simit", "pogaca", "borek", "corek", "pide", "pizza", "makarna",
    "pilav", "corba", "peynir", "yogurt", "kaymak", "recel", "pekmez", "tahin",
    // Spor
    "futbol", "basketbol", "voleybol", "hentbol", "tenis", "badminton", "golf", "polo",
    "yuzme", "kosu", "kayak", "paten", "sorf", "yelken", "okculuk", "eskrim",
    // Meslekler
    "doktor", "ogretmen", "pilot", "kaptan", "mimar", "muhendis", "ressam", "yazar",
    "sair", "asci", "terzi", "berber", "ciftci", "bahcivan", "marangoz", "veteriner",
    // Yapilar
    "ev", "okul", "hastane", "kutuphane", "muze", "tiyatro", "sinema", "stadyum",
    "saray", "kale", "kule", "kopru", "liman", "istasyon", "gar", "terminal",
    // Cografya
    "kiyi", "sahil", "kumsal", "plaj", "koy", "korfez", "bogaz", "burun",
    "yarimada", "selale", "magara", "kanyon", "doruk", "zirve", "yamac", "gecit",
    // Hava ve zaman
    "kar", "dolu", "sis", "cig", "kiragi", "firtina", "meltem", "poyraz",
    "lodos", "simsek", "gokkusagi", "sabah", "ogle", "aksam", "gece", "seher",
    // Maddeler
    "altin", "gumus", "bakir", "demir", "celik", "bronz", "mermer", "granit",
    "kil", "kum", "tas", "toprak", "pamuk", "ipek", "yun", "keten",
    // Geometri
    "kare", "daire", "ucgen", "dikdortgen", "besgen", "altigen", "sekizgen", "oval",
    "kup", "kure", "silindir", "koni", "prizma", "piramit", "cember", "elips",
    // Vucut
    "el", "kol", "omuz", "dirsek", "bilek", "parmak", "tirnak", "ayak",
    "diz", "topuk", "sac", "kas", "goz", "kulak", "yanak", "kirpik",
    // Aletler
    "cekic", "pense", "kerpeten", "tornavida", "anahtar", "vida", "civi", "somun",
    "matkap", "testere", "balta", "kurek", "tirpan", "capa", "firca", "merdiven",
    // Nitelikler
    "mutlu", "neseli", "sakin", "nazik", "cesur", "merakli", "sevimli", "parlak",
    "renkli", "serin", "sicak", "tatli", "tuzlu", "eksi", "yumusak", "hafif",
    // Hobiler ve oyunlar
    "resim", "heykel", "seramik", "orgu", "nakis", "origami", "fotograf", "dans",
    "satranc", "dama", "tavla", "domino", "yapboz", "bulmaca", "piknik", "kamp",
];
/** Modulo yanlılığını reddetme örneklemesiyle önler; Math.random yedeği yoktur. */
function rastgeleIndis(ustSinir) {
    const sinir = Math.floor(0x1_0000_0000 / ustSinir) * ustSinir;
    const veri = new Uint32Array(1);
    do {
        globalThis.crypto.getRandomValues(veri);
    } while (veri[0] >= sinir);
    return veri[0] % ustSinir;
}
/** İki bağımsız kelime + iki rakam; 26.214.400 olasılık, benzersizlik garantisi yok. */
export function veliParolasiUret() {
    if (!globalThis.crypto?.getRandomValues) {
        throw new Error("Bu ortamda güvenli şifre üretilemiyor. Lütfen tekrar deneyin.");
    }
    const kelimeler = Array.from({ length: 2 }, () => KELIMELER[rastgeleIndis(KELIMELER.length)]);
    const sayi = String(rastgeleIndis(100)).padStart(2, "0");
    return `${kelimeler.join("-")}.${sayi}`;
}
//# sourceMappingURL=veliParolasi.js.map